module.exports = fox._r("fonts/simplifica.ttf", __webpack_public_path__ + "_/_/_/root/fonts/qrc--6E.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/simplifica.ttf
// module id = 222
// module chunks = 4